<template>
  <div class="cursor-pointer mb-1" v-click-outside="closeDropdown">
    <div class="grid grid-cols-10 mt-1.5 title" @click="openDropdown()">
      <p class="text-left title-text">{{ title }}<sup v-if="hasSelectedValue"
                                                      class="text-xxs text-red-500 "><i
        class="fas fa-circle"></i></sup></p>
      <div class="text-right">
        <font-awesome-icon v-if="!isVisible" icon="angle-down"/>
        <font-awesome-icon v-if="isVisible" icon="angle-up"/>
      </div>
    </div>

    <div v-if="isVisible" class="grid content"
         :class="{'grid-cols-1 single': mode==='single','grid-cols-2 double': mode==='double'}">
      <div v-for="facet in facets"
           @click="toggleSelected(facet)">
        <div class="flex items-center cursor-pointer">
          <c-checkbox :selected="facet.selected"/>
          <label class="cursor-pointer">{{ facet.name }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ClickOutside from 'vue-click-outside'
import Vue from "vue";
import CustomCheckbox from "../form/CustomCheckbox";
import EventBus from "../../services/EventBus";

export default {
  name: "DropDownFacet",

  components: {
    'c-checkbox': CustomCheckbox
  },

  props: {
    title: {required: true, type: String},
    facets: {required: true},
    mode: {required: false, type: String, default: 'single'},
    height: {required: false, type: String, default: ''},
  },

  data() {
    return {
      isVisible: false,
    }
  },

  created() {
    EventBus.listen('close-dropdowns', this.closeDropdown)
  },

  destroyed() {
    EventBus.destroy('close-dropdowns', this.closeDropdown)
  },

  computed: {
    hasSelectedValue() {
      if (!this.facets) {
        return false
      }

      return this.facets.find((facet) => {
        return facet.selected === true;
      });
    }
  },

  methods: {
    closeDropdown() {
      this.isVisible = false;
    },

    openDropdown() {
      if (this.isVisible) {
        this.isVisible = false;
        return
      }
      EventBus.fire('close-dropdowns');
      EventBus.fire('close-nav');
      EventBus.fire('close-menus');

      this.isVisible = !this.isVisible
    },

    toggleSelected(facet) {
      Vue.set(facet, 'selected', !facet.selected)
    }
  },

  directives: {
    ClickOutside
  }
}
</script>

<style scoped>
.title {
  border-bottom: 2px solid #EAEBEC;
  height: 44px;
  line-height: 44px;
}

.content {
  max-height: 15vh;
  overflow-y: auto;
}

.content::-webkit-scrollbar {
  /*display: none;*/
}

.title-text {
  grid-column: 1 / 10;
}

@media screen and (max-width: 1716px) {
  .content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}

@media screen and (min-width: 3000px) {
  .double {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>
